"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Xdadevelopers = function Xdadevelopers(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.547 6.502a.193.193 0 00-.131.19v2.396h-3.617c-.783 0-1.421.208-1.887.64-.468.436-.701 1.066-.701 1.852v3.416c-.01.089-.024.184-.024.285 0 .482.142.933.417 1.328.277.4.659.673 1.115.795.254.07.606.096 1.092.096h1.779c.86 0 1.529-.198 1.992-.617.463-.42.687-1.043.688-1.828V6.693a.193.193 0 00-.19-.19h-.475a.193.193 0 00-.058-.001zM.2 9.086a.193.193 0 00-.02.002.193.193 0 00-.095.308l3.049 3.915-3.096 3.878a.193.193 0 00.154.309h.641a.193.193 0 00.154-.07l2.692-3.416 2.68 3.416a.193.193 0 00.154.07h.629a.193.193 0 00.154-.309L4.238 13.3l3-3.903a.193.193 0 00-.154-.308h-.64a.193.193 0 00-.155.07l-2.61 3.428-2.644-3.428a.193.193 0 00-.154-.07H.24a.193.193 0 00-.04-.002zm16.986 0a.193.193 0 00-.019.002.193.193 0 00-.13.19v.486a.193.193 0 00.189.19h4.4c.541 0 .913.125 1.15.357.238.23.37.59.37 1.115v.332h-3.844c-.686 0-1.26.21-1.672.629-.412.418-.617.985-.617 1.672v1.197c0 .569.17 1.07.51 1.459.003.004.008.007.011.012.432.512 1.06.771 1.815.771h2.408c.706 0 1.281-.21 1.672-.64.386-.426.57-1.01.57-1.721V11.52c0-.784-.211-1.41-.664-1.827-.453-.416-1.118-.605-1.957-.605h-4.152a.193.193 0 00-.04-.002zm-6.402.879h3.631v5.066c0 .495-.143.846-.404 1.104-.257.254-.655.433-1.221.498h-.156a.193.193 0 00-.024 0 1 1 0 01-.142.012h-1.672c-.683 0-1.13-.153-1.363-.381-.233-.23-.381-.659-.381-1.34v-3.309c0-.649.234-1.102.713-1.424v.012c.217-.142.556-.238 1.02-.238zm8.483 2.644v.002h3.867v2.645c0 .495-.12.828-.332 1.045-.212.217-.538.344-1.022.344h-2.467a1.27 1.27 0 01-.224-.024c-.43-.075-.732-.238-.926-.463-.194-.225-.297-.525-.297-.937v-1.176c0-.43.108-.747.297-.973.187-.223.47-.37.877-.437h.012c.112-.017.187-.026.215-.026Z"
  }));
};

Xdadevelopers.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Xdadevelopers.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Xdadevelopers;
exports["default"] = _default;